
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.667 5.553a2.01 2.01 0 001.22-1.22H12L10 9c0 1.107 1.047 2 2.333 2 1.287 0 2.334-.893 2.334-2l-2-4.667H14V3H9.887A1.994 1.994 0 008 1.667c-.873 0-1.613.553-1.887 1.333H2v1.333h1.333L1.333 9c0 1.107 1.047 2 2.334 2C4.953 11 6 10.107 6 9L4 4.333h2.113c.2.567.654 1.02 1.22 1.22V13h-6v1.333h13.334V13h-6V5.553zM13.58 9h-2.493l1.246-2.907L13.58 9zM4.913 9H2.42l1.247-2.907L4.913 9zM8 4.333a.669.669 0 01-.667-.666C7.333 3.3 7.633 3 8 3c.367 0 .667.3.667.667 0 .366-.3.666-.667.666z","fill":"currentColor"}})])
          )
        }
      }
    